module.exports = "<div class=\"title\"><%= data.Title %></div>\n\n<div class=\"text\"><%= data.Text %></div>\n\n"